export default {
  menu: {
    home: 'ホーム',
    alliance: 'マイアライアンス',
    mall: 'ポケットモール',
    me: '会社概要'
  },
  layout: {
    loading: '読み込み中',
    trading: '取引中です。しばらくお待ちください...',
    comingsoon: '近日公開',
    success: '成功',
    error: '失敗'
  },
  header: {
    home: 'ホーム',
    alliance: 'マイアライアンス',
    mall: 'ポケットモール',
    about: '会社概要',
    lang: {
      zh: '简体中文',
      zhTW: '繁體中文',
      en: 'English',
      ko: '한국어',
      ja: '日本語'
    }
  },
  period: {
    m5: '5分',
    m15: '15分',
    h1: '1時間',
    h4: '4時間',
    d1: '日',
    w1: '週',
    m1: '月'
  },
  home: {
    slogan1: '資産価値を高める',
    slogan2_part1: '',
    slogan2_pocket: 'ポケット',
    slogan2_part2: 'から始めよう',
    slogan3: '安全・安定・高収益',
    explore: 'もっと見る',
    alliance_pack: 'ポケットアライアンスパッケージ',
    alliance_desc: '最大5,000元相当のレアカードを獲得できるチャンス！さらにポケットトークンをプレゼント、累計最大360元の特典を受け取れます！',
    join_alliance: 'ポケットアライアンスに参加',
    mall: 'ポケットモール',
    mall_desc: 'ただのショッピングではなく、新しい貯蓄の形です。',
    ecosystem: '戦略パートナー - DRS',
    ecosystem_desc: '協同組合を支援し、公務員の負担を軽減します。',
    referrer_title: '紹介者アドレス',
    referrer_placeholder: '紹介者アドレスを入力してください',
    confirm: '確認'
  },
  alliance: {
    mint_pool: '鋳造プール',
    token_count: 'TOKEN数量',
    usdt_total: 'USDT総量',
    open_price: '始値',
    current_value: '現在価値',
    static_income: '静的収益',
    my_token: '保有TOKEN数量',
    withdraw: '出金',
    fill_address: '住所入力',
    view_receipt: '配送情報を見る',
    dynamic_income: '動的収益',
    current_node: '現在のノード',
    large_node: '大型ノード',
    repurchase_count: '再購入回数',
    current_pack: '現在のパッケージ',
    max_return: '最大収益',
    withdrawn_income: '出金済み収益',
    current_income: '現在の収益',
    my_pack: 'マイパッケージ',
    referrer_address: '紹介者アドレス',
    community_subsidy: 'コミュニティ補助金',
    buy_node: 'ノード購入',
    my_team: 'マイチーム',
    team_pack: 'チームパッケージ',
    team_small_node: 'チーム小型ノード',
    team_large_node: 'チーム大型ノード',
    my_referrals: '紹介メンバー',
    node: 'ノード',
    date: '日付',
    small_node: '小型ノード',
    recommend: '推薦',
    high_return: '高収益',
    buy: '購入',
    small_node_desc: '個人ユーザー向けで、コストパフォーマンスが高く、エコシステム構築に気軽に参加できます。',
    large_node_desc: '上級ユーザー向けで、より高い収益とエコシステム参加機会を提供します。',
    fill_receipt_info: '配送情報入力',
    select_region: '地域を選択',
    select_address: '住所',
    receiver: '受取人',
    phone: '連絡先電話番号',
    submit: '送信',
    cancel: 'キャンセル',
    purchase_node: 'ノード購入',
    select_node: '購入するノードを選択してください',
    your_address: '配送先住所',
    your_phone: '連絡先電話番号',
    shipping_status: '配送状況',
    shipp: '発送待ち',
    shipped: '発送済み',
    shipping_method: '配送方法',
    tracking_number: '追跡番号',
    close: '閉じる',
    postcode: '郵便番号',
    endvalue: '最終収益',
    copylink: '招待リンクをコピー',
    fundinfo: '詳細',
    myorder: '注文履歴',
    orderno: '注文番号',
    getthings: '受け取る',
    geted: '受取済み',
    gettime: '受取日時',
    packamount: 'パッケージ金額',
    nonode: 'なし',
    teamsub: 'コミュニティ補助金',
    pocketname: 'ポケットアライアンス',
    pocketname1: 'ご支援とご参加、誠にありがとうございます！',
    pocketname2: '指定された店舗で商品をお受け取りください。幸運に恵まれ、お気に入りのレアカードが当たりますように！',
    nodealert:'ahwehwɛde ho akontaabu',
    nodealert2:'nnipa',
  },
  me: {
    about_alliance: 'ポケットアライアンスについて',
    alliance_rule1: 'ポケットアライアンスは、Web3を中核とした革新的なエコシステムアライアンスで、消費価値向上、貯蓄価値向上、コレクション価値、金融価値向上を統合した価値エコシステムの構築に取り組んでいます。',
    alliance_rule2: '私たちは、シンプルでわかりやすく、参加のハードルが低い方法で、より多くの人々がWeb3時代の機会に触れ、長期的な資産価値の蓄積と成長を実現できることを目指しています。',
    alliance_rule3: 'ポケットアライアンスは、**ボードゲームによるソーシャル体験**を入口として、楽しくインタラクティブな方法で人々の信頼とつながりを築きます。**コミュニティ共創**を基盤に、共有・学習・協力を通じて活気ある価値ネットワークを構築します。',
    alliance_rule4: 'ポケットアライアンスのエコシステムでは、消費はもはや単なる支出ではなく、貯蓄は単なる預金ではなく、コレクションは単なる趣味ではなく、持続的に価値を生み出すサイクルとなります。',
    alliance_rule5: '私たちのビジョン',
    alliance_rule6: 'すべての人が自分自身の価値のポケットを持ち、Web3時代に資産を確保・蓄積・継承できる世界を目指します。',
    alliance_rule7: '私たちのミッション',
    alliance_rule8: 'ソーシャルで価値をつなぎ、エコシステムで増価を生み出し、Web3をすべての家庭に届けます。',
    alliance_rule9: '私たちのコアバリュー',
    alliance_rule10: '💰 消費価値向上 — すべての消費をより価値あるものに',
    alliance_rule11: '🏦 貯蓄価値向上 — 資金に成長のチャンスを',
    alliance_rule12: '🃏 コレクション価値 — 趣味を資産に変える',
    alliance_rule13: '📈 金融価値向上 — 価値を持続的に循環させる',
    alliance_rule14: '🤝 コミュニティ共創 — 共有がより大きな価値を生む',
    alliance_rule15: '🌐 Web3エンパワーメント — すべての人が未来の経済に参加できる',
    alliance_rule16: 'ポケットアライアンス — 消費を資産に、交流を価値に、未来をポケットに。',
    alliance_rule17: 'ポケットアライアンス — すべてのメンバーのポケットにお金を',
    about_node: 'ノードについて',
    node_rule1: '1. 300Uを投資して、小ノードになる',
    node_rule2: '2. 800Uを投資して、大ノードになる',
    pocketname: 'ポケットトークン',
    pocketprice: '現在の時価',
    pockettrade: '取引高',
},
  mall: {
    coming_soon: '近日公開...'
  },
  chart: {
    open: '始値',
    close: '終値',
    high: '高値',
    low: '安値',
    change: '変動額',
    change_rate: '変動率',
    volume: '出来高'
  }
};